import { useSelector } from 'react-redux';
import Currency from 'react-currency-formatter';

const Price = ({ price = 0, placeholder }) => {
    const { currencyRate, currencyCode } = useSelector(state => state.config);
    const priceValue = Number(price * currencyRate);
    return typeof placeholder !== 'undefined' && !priceValue ?
    placeholder : <Currency quantity={priceValue} currency={currencyCode} pattern="##,### !" group=" " />;
}

export default Price;
